<template>
  <div class="w-full flex-1 flex-col  lg:ml-base">
    <vx-card>
      <template slot="no-body">
        <global-header :buttonBack="true" :actions="false">
          <template slot="actions-custom">
            <vs-button
              type="border"
              color="primary"
              icon-pack="feather"
              icon="icon-edit"
              @click="
                $router.push({
                  name: 'edit-buku-kendali',
                  params: { uuid: nomorSuratByUuid.uuid }
                })
              "
              ><div class="hidden sm:block">Ubah</div></vs-button
            >
          </template>
        </global-header>
        <div class="w-full px-5 pb-5">
          <div class="flex flex-col md:flex-row">
            <div class="w-full flex-1 mb-3">
              <div class="w-full font-bold">Nomor Surat</div>
              <p>{{ nomorSuratByUuid.nomor }}</p>
            </div>
            <div class="w-full flex-1 mb-3">
              <div class="w-full font-bold">Kode Surat</div>
              <p>{{ nomorSuratByUuid.kode_surat }}</p>
            </div>
            <div class="w-full flex-1 mb-3">
              <div class="w-full font-bold">Urutan</div>
              <p>{{ nomorSuratByUuid.angka }}</p>
            </div>
          </div>
          <vs-divider></vs-divider>
          <div class="flex flex-col md:flex-row">
            <div class="w-full mb-3">
              <div class="w-full font-bold">Tipe Surat</div>
              <p>
                {{
                  nomorSuratByUuid.tipe == "surat_masuk"
                    ? "Surat Masuk"
                    : "Surat Keluar"
                }}
              </p>
            </div>
            <div class="w-full mb-3">
              <div class="w-full font-bold">Tanggal</div>
              <p>{{ nomorSuratByUuid.tanggal }}</p>
            </div>
            <div class="w-full" v-if="nomorSuratByUuid.surat_id != null">
              <div class="w-full font-bold mb-2">Surat</div>
              <div class="w-full">
                <p>Judul : {{ nomorSuratByUuid.surat.index }}</p>
                <a
                  class="cursor-pointer"
                  @click="
                    $router.push({
                      name: 'surat-lihat',
                      params: { uuid: nomorSuratByUuid.surat.uuid }
                    })
                  "
                  >Lihat Surat</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>
    </vx-card>
  </div>
</template>

<script>
import { GET_DETAIL } from "@/query/nomor-surat";
import moment from "moment";

export default {
  data() {
    return {
      nomorSuratByUuid: []
    };
  },
  apollo: {
    nomorSuratByUuid: {
      query: GET_DETAIL,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    }
  },
  components: {
    moment: moment
  },
  mounted() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Detail Nomor Surat");
  }
};
</script>
